module.exports = __webpack_public_path__ + "9a8c8b40.png";